import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { NgxsModule } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';

import { MapModule } from '@shared/components/map/map.module';
import { SmallCardComponent } from 'app/modules/main/components/small-card/small-card.component';
import { RatingModule } from '@shared/components/rating/rating.module';
import { FooterModule } from '@shared/components/footer/footer.module';
import { SvgModule } from '@shared/components/svg/svg.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MapCarouselWrapperComponent } from 'app/modules/main/components/map-carousel-wrapper/map-carousel-wrapper.component';
import { CarouselModule } from '@shared/components/carousel/carousel.module';
import { MainPageService } from 'app/modules/main/services/main-page.service';
import { MainPageState } from 'app/modules/main/store/main-page.state';
import { SocialShareModule } from '@shared/components/social-share/social-share.module';
import { DeclensionWordModule } from '@shared/pipes/declension-word/declension-word.module';
import { CatalogItemCardInfoModule } from 'app/modules/data/shared/components/catalog-item-card-info/catalog-item-card-info.module';
import { VkCardModule } from '@shared/components/vk-card/vk-card.module';
import { LoaderModule } from '@shared/components/loader/loader.module';
import { HoverableSvgModule } from '@shared/components/hoverable-svg/hoverable-svg.module';
import { CustomToolTipModule } from '@shared/directives/custom-tool-tip/custom-tool-tip.module';
import { SafeHtmlModule } from '@shared/pipes/safe-html/safe-html.module';
import { MainComponent } from './components/main/main.component';
import { CarouselCardComponent } from './components/carousel-card/carousel-card.component';
import { ApplicationCardComponent } from './components/application-card/application-card.component';
import { UsefulLinksComponent } from './components/useful-links/useful-links.component';
import { LeftTextBlockComponent } from './components/left-text-block/left-text-block.component';
import { RightTextBlockComponent } from './components/right-text-block/right-text-block.component';
import { UsefullLinksCarouselComponent } from './components/usefull-links-carousel/usefull-links-carousel.component';
import { VkBlockComponent } from './components/facebook-block/vk-block.component';
import { MobileAppsBlockComponent } from './components/mobile-apps-block/mobile-apps-block.component';
import { MobileAppsCardComponent } from './components/mobile-apps-card/mobile-apps-card.component';
import { SmallCardBlockComponent } from './components/small-card-block/small-card-block.component';
import { CatalogTableState } from '../data/modules/catalog-data/store/catalog-table.state';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    MainComponent,
    SmallCardComponent,
    CarouselCardComponent,
    ApplicationCardComponent,
    UsefulLinksComponent,
    LeftTextBlockComponent,
    RightTextBlockComponent,
    UsefullLinksCarouselComponent,
    VkBlockComponent,
    MobileAppsBlockComponent,
    MobileAppsCardComponent,
    SmallCardBlockComponent,
    MapCarouselWrapperComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    RouterModule.forChild([
      { path: '', component: MainComponent }
    ]),
    MatButtonModule,
    TranslateModule,
    SvgModule,
    RatingModule,
    FooterModule,
    NgLetModule,
    MapModule,
    CarouselModule,
    NgxsModule.forFeature([MainPageState, CatalogTableState]),
    SocialShareModule,
    DeclensionWordModule,
    CatalogItemCardInfoModule,
    VkCardModule,
    LoaderModule,
    MatTooltipModule,
    HoverableSvgModule,
    CustomToolTipModule,
    SafeHtmlModule
  ],
  bootstrap: [MainComponent],
  providers: [MainPageService, DatePipe]
})
export class MainModule {}
